
import ContratoTermosAdesao from "@/components/contratos/ContratoTermosAdesao.vue";
import ContratoFlexFamilia from "@/components/contratos/ContratoFlexFamilia.vue";
import ContratoFlexMulti from "@/components/contratos/ContratoFlexMulti.vue";

export default {
  components: {
    ContratoTermosAdesao,
    ContratoFlexFamilia,
    ContratoFlexMulti,
  },
  data: () => ({
    navigation: [
      {
        name: "Contrato Termos Adesao",
        icon: "mdi-file-document-edit-outline",
      },
      {
        name: "Contrato Flex Familia",
        icon: "mdi-file-document-box-outline",
      },
      {
        name: "Contrato Flex Multi",
        icon: "mdi-file-document-box-outline",
      },
    ],
  }),
};
